"use client";

import { useEffect, useRef } from "react";
import { ReviewsType } from "commonModule/services/favorite/types";
import NewMessageIcon from "components/icons-svg/NewMessageIcon";
import Reviews from "./Reviews";
export const scrollReviewSectionIntoView = () => {
  const element = document.getElementById("reviewSection");
  element?.scrollIntoView({
    block: "start",
    behavior: "smooth"
  });
};
export const RatingBreakdown = ({
  ratingPercentages
}: {
  ratingPercentages: Partial<Record<number, number>>;
}) => {
  const sortedStars = Object.keys(ratingPercentages).map(Number).sort((a, b) => b - a); // Sort descending: 5 → 1
  return <div className='sm:w-[202px] sm:max-w-[202px]' data-sentry-component="RatingBreakdown" data-sentry-source-file="ReviewsSection.tsx">
      {sortedStars.map(star => {
      const percentage = ratingPercentages[star] || 0;
      return <div key={star} className='mb-[1px] flex items-center gap-1'>
            <span className='w-2 text-xs font-medium text-black-900'>
              {star}
            </span>
            <div className='h-1.5 flex-1 rounded bg-[#D9D9D9]'>
              <div className='h-full rounded bg-[#008292]' style={{
            width: `${percentage}%`
          }} />
            </div>
          </div>;
    })}
    </div>;
};
const ReviewsSection = ({
  ratingOutOf5,
  reviews,
  property_rating_star_sum,
  property_id,
  property_rating_user_count,
  propertyReviewSummary
}: {
  property_rating_star_sum?: number | null;
  ratingOutOf5: number;
  reviews?: ReviewsType[] | null;
  property_id: string;
  property_rating_user_count?: number | null;
  propertyReviewSummary?: Partial<Record<number, number>> | null;
}) => {
  const reviewSectionRef = useRef<HTMLDivElement | HTMLParagraphElement | null>(null);

  // Event to trigger – when review section enters in viewport
  useEffect(() => {
    const element = reviewSectionRef.current;
    if (!element) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          void (async () => {
            const mixpanelV2Client = (await import("services/mixpanelv2")).mixpanelV2Client;
            mixpanelV2Client.VIEW_REVIEWS({
              propertyId: property_id || "",
              reviewCount: property_rating_user_count || 0,
              rating: ratingOutOf5 || 0
            });
          })();
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.2
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [property_id]);
  if (!ratingOutOf5 || !reviews || reviews && reviews?.length == 0) {
    return <p ref={reviewSectionRef} className='scroll-mt-36 text-xl font-semibold' id='reviewSection'>
        No reviews yet
      </p>;
  }
  return <div ref={reviewSectionRef} id='reviewSection' className='relative flex scroll-mt-28 flex-col gap-4 bg-white' data-sentry-component="ReviewsSection" data-sentry-source-file="ReviewsSection.tsx">
      <div>
        <div className='mb-2 mt-7 items-center justify-between gap-2 sm:flex md:mt-0 lg:mt-7 lg2:mt-0'>
          <div className='flex items-center justify-between gap-2 sm:block'>
            <div className='my-1 flex items-center gap-2'>
              <NewMessageIcon className='h-[14px] w-[16px] md:h-[17.5px] md:w-[20px]' data-sentry-element="NewMessageIcon" data-sentry-source-file="ReviewsSection.tsx" />
              <h3 className='text-base font-semibold leading-[19.2px] tracking-[-0.24px] text-black-800  md:text-xl md:leading-6 md:tracking-[-0.3px]'>
                Guest reviews
              </h3>
            </div>
            {/* <div className='-ml-[1px] mb-0.5 flex items-center gap-0.5 text-base font-bold'>
              <StarIcon className='h-[18px] w-[18px] text-[#FFB940]' />{" "}
              {reviews && reviews.length > 0 && `${ratingOutOf5.toFixed(1)} `}
              <span className='whitespace-nowrap text-base font-medium text-grayText'>
                <span className='pl-0.5 text-base font-medium text-[#d1cece]'>
                  {" "}
                  |{" "}
                </span>
                {(reviews &&
                  reviews.length > 0 &&
                  `${property_rating_user_count}
                  ${
                    property_rating_user_count === 1 ? "review" : "reviews"
                  }`) ||
                  ratingOutOf5}
              </span>
             </div> */}
          </div>
          <div className='mt-3 sm:mt-0 sm:w-[202px] sm:min-w-[202px]'>
            {/* Overall Rating */}
            {propertyReviewSummary && <div>
                <RatingBreakdown ratingPercentages={propertyReviewSummary} />
              </div>}
          </div>
        </div>
        <div>
          {/* add some reviews here */}
          {reviews && reviews.length > 0 && <Reviews reviews={reviews} ratingStarSum={property_rating_star_sum} propertyId={property_id} propertyRatingUserCount={property_rating_user_count} ratingPercentages={propertyReviewSummary} />}
        </div>
      </div>
    </div>;
};
export default ReviewsSection;